export const MISO_WHITEPAPER_URL =
    "https://cdn.misoenergy.org/MISO%20Transmission%20Mitigation%20Selection%20and%20Cost%20Estimation%20Approach%20Whitepaper697460.pdf";
